<template>
    <vs-chip class="ag-grid-cell-chip" :color="chipColor(params)">
        <span>{{ organizationTypeString(params) }}</span>
    </vs-chip>
</template>

<script>
export default {
    name: 'CellRendererStatus',
    computed: {
        chipColor() {
            return value => {
                if (value.data.status === 0) {
                    return "danger"
                } else if (value.data.status === 1) {
                    return "success"
                }
            }
        },
        organizationTypeString() {
            return value => {
                if (value.data.status === 0) {
                    return this.$t('root.stopWorking')
                } else if (value.data.status === 1) {
                    return this.$t('root.active')
                }
            }
        }
    }
}
</script>

<style lang="scss" scpoped>

</style>
